import { usePreference } from '../../../Data/Preference';

const usePinnedConversation = () => {
    const [pinnedConversationId, setPinnedConversationId] = usePreference('admin:pinnedConversation', null);

    return {
        pinnedConversationId,
        isPinned: (conversationId) => {
            return pinnedConversationId === conversationId;
        },
        pin: (conversationId) => {
            setPinnedConversationId(conversationId);
        },
        unpin: () => {
            setPinnedConversationId(null);
        },
    };
}

export {
    usePinnedConversation,
}
